import Image from 'next/image'

import CSS from './offset-callout.module.css'

export const OffsetCallout = ({ children, hero, noOverlapTop, noOverlapBottom, followsHeader, theme, imageGraphic, contentGraphic }) => {

    // console.log('from compontent - contentGraphic:', contentGraphic)

    return (
        <section className={`
            ${CSS.layout} 
            ${noOverlapBottom ? '' : CSS.noOverlapBottom} 
            ${noOverlapTop ? '' : CSS.noOverlapTop}
            ${followsHeader && CSS.followsHeader}
        `}
        >

            <div className={`${CSS.content} block ${theme ? theme : 'bg-white'}`} >
                { children }
            </div>

            {/* {
                contentGraphic && contentGraphic.url ?
                <div className={CSS.contentGraphic}>
                    <Image src={contentGraphic.url} layout={`responsive`} width={contentGraphic.width} height={contentGraphic.height} alt="" />
                </div>
                : null
            } */}
           
            
            <div className={CSS.image}>
                {
                    hero && hero.url ?
                       <Image src={hero.url} layout={`fill`} width={hero.width} height={hero.height} alt="" />
                    :
                       <Image src={`/assets/img/homepage/about.jpg`} layout={`fill`} alt="" />
                }
                
            </div>
            
            {/* {
                imageGraphic && imageGraphic.url ?
                    <div className={CSS.imageGraphic}>
                        <Image src={imageGraphic.url} layout={`responsive`} width={imageGraphic.width} height={imageGraphic.height} alt="" />
                    </div>
                : null
            } */}
        
        </section>
    )
}